//libs
import { styled } from '@nykaa/ui-components';

//components
import Image from 'shared/components/ImageV2';

//mixins
import { truncate } from 'shared/styles/mixin/core';

//constants
import { MWEB_HEADER_ZINDEX } from 'shared/styles/base';

export const HeaderContainer = styled.header<{ isScroll: boolean }>`
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  height: var(--header-height);
  display: block;
  align-items: center;
  z-index: ${MWEB_HEADER_ZINDEX};

  ${({ theme, isScroll }) =>
    `padding: ${theme.spacing.spacing40} ${theme.spacing.spacing120} ${theme.spacing.spacing100} ${
      theme.spacing.spacing120
    }; 
    background-color:  ${theme.colors.surface};
    ${
      isScroll &&
      `border-bottom: 1px solid ${theme.colors.textOutline};
        .top-image{   
            opacity: 1;
            transition: 300ms opacity ease-in;
        }
        .header-content{
          left: 50px;
          transition: 300ms left ease-in;
        }
      `
    };
  `};
`;

export const Cross = styled.button`
  cursor: pointer;
  border: none;
  background: none;
  padding-left: 0;
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  ${({ theme }) => theme.typography.titleLarge};
  margin-top: ${({ theme }) => theme.spacing.spacing120};
  height: 100%;
  position: relative;
  left: 0;
  transition: 300ms left ease-in;
`;

export const Description = styled.div`
  position: relative;
  text-align: left;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-start;
  width: 80%;
  padding: ${({ theme }) =>
    `${theme.spacing.spacing20} ${theme.spacing.spacing60} ${theme.spacing.spacing40}`};
`;

export const Title = styled.div`
  ${truncate}
  ${({ theme }) =>
    `
    ${theme.typography.subTitleMedium};
    color: ${theme.colors.textPrimary};
    margin-bottom: ${theme.spacing.spacing10};
  `};
`;

export const SubTitle = styled.div`
  ${truncate};
  ${({ theme }) =>
    `
    color: ${theme.colors.textPrimary};
    margin-bottom: ${theme.spacing.spacing40};
    ${theme.typography.bodyMedium};
  `};
`;

export const OfferMessage = styled.div`
  ${({ theme }) =>
    `
      color: ${theme.colors.positive};
      ${theme.typography.bodySmall}
      margin-top: ${theme.spacing.spacing20}
  `};
`;

export const SizeSoldout = styled.div`
  ${({ theme }) =>
    `
    color: ${theme.colors.warning};
    ${theme.typography.bodySmall}
    margin-top: ${theme.spacing.spacing20}
  `};
`;

export const SelectedImage = styled(Image)`
  height: 80px;
  width: 80px;
  object-fit: cover;
  object-position: 0% 0%;
  border-radius: ${({ theme }) => theme.borders.radius30};
  &.top-image {
    position: absolute;
    width: 40px;
    height: 40px;
    top: 55px;
    opacity: 0;
    transition: 300ms opacity ease-out;
  }
`;

export const ProductDetails = styled.div<{ isScroll: boolean }>`
  display: flex;
  position: relative;
  opacity: 1;
  transition: 300ms opacity ease-in;
  ${({ theme }) =>
    `
     padding: 0 ${theme.spacing.spacing60} ${theme.spacing.spacing80};
     margin: ${`0 ${theme.spacing.spacing80} ${theme.spacing.spacing100} ${theme.spacing.spacing60}`};
    `};
  ${({ isScroll }) =>
    isScroll &&
    `
      opacity: 0;
      transition: 300ms opacity ease-out;
      height: 6%;
    `};
`;
export const HeadingWithImage = styled.div`
  display: flex;
`;
